<template>
  <div class="list-container">
    <div class="top-fix-area" ref="topFixArea">
      <h1 class="page-title">建物種別マスタ情報一覧</h1>
      <div class="mb-2">
        <router-link
          v-if="userRole == 0 || userRole == 999"
          :to="{ path: '/create-building-type', query: getSearchQuery() }"
          class="btn btn-sm btn-primary mx-2"
        >
          建物種別マスタ情報作成
        </router-link> <!-- 建物種別マスタ情報作成ページへのリンク -->

        <!-- Button trigger modal -->
        <button v-if="userRole == 999" type="button" class="btn btn-sm btn-primary me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          CSVインポート
        </button>

        <!-- Button trigger modal -->
        <button type="button" class="btn btn-sm btn-primary me-2" @click="downloadCsv">CSVエクスポート</button>

        <button
          v-if="userRole == 0 || userRole == 999"
          type="button"
          class="btn btn-sm btn-outline-primary me-2"
          data-bs-toggle="modal"
          data-bs-target="#fieldVisibilityModalBuildingType"
          @click="openFieldVisibilityModal"
        >
          測定表示項目設定
        </button>
        
        <button class="btn btn-sm btn-outline-secondary" @click="isSearchExpanded = !isSearchExpanded">
          {{ isSearchExpanded ? '検索条件を非表示' : '検索条件を表示' }}
        </button>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">CSVインポート</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="clearErrorMessages"></button>
            </div>
            <div class="modal-body">
              <div v-if="errorMessages" >
                <div class="error-massage-item" v-for="errorMessage in errorMessages" :key="errorMessage.id">
                  <p class="alert alert-danger mt-2">{{ errorMessage.row_num }}行目：{{errorMessage.messages[0]}}</p>
                </div>
              </div>

              <div class="my-3">
                <p>建物種別情報CSVファイル選択</p>
                <input type="file" class="form-control" @change="handleFileChange">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="clearErrorMessages">閉じる</button>
              <button type="button" class="btn btn-primary" @click="submitFile">インポート</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="fieldVisibilityModalBuildingType" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5">測定システム表示項目設定（建物種別）</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <table class="table table-bordered align-middle">
                <thead class="table-light">
                  <tr>
                    <th>項目名</th>
                    <th>キー</th>
                    <th class="text-center">表示</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="field in fieldVisibilityFields" :key="field.field_name">
                    <td>{{ field.field_label }}</td>
                    <td class="text-muted">{{ field.field_name }}</td>
                    <td class="text-center">
                      <div class="form-check form-switch d-inline-block">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :checked="field.readable"
                          :disabled="field.configurable === false || isSavingFieldVisibility"
                          @change="updateFieldReadable(field.field_name, $event.target.checked)"
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">閉じる</button>
              <button type="button" class="btn btn-primary" :disabled="isSavingFieldVisibility" @click="saveFieldVisibility">保存</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 検索バーの追加 -->
      <SearchPanelWrapper :key="route.fullPath" v-model="isSearchExpanded" :getTableElement="() => tableWrapper?.$el || tableWrapper?.value" >
        <form class="search-container" style="background-color: #f8f9fa;" @submit.prevent="searchBuildingTypes"> <!-- 背景色を薄く設定 -->
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="searchName" class="col-form-label">建物種別名</label>
            </div>
            <div class="col-auto">
              <input type="text" id="searchName" class="form-control" v-model="searchName" placeholder="建物種別名で検索">
            </div>

            <DeletedStatusSelect v-model="searchDeletedStatus" id="buildingTypeDeletedStatus" />

            <div class="col-auto">
              <button type="submit" class="btn btn-primary">検索</button>
              <button type="button" class="btn btn-secondary mx-1" @click="searchResetBuildingTypes">クリア</button>
            </div>
          </div>
        </form>
      </SearchPanelWrapper>
    </div>

    <div class="d-flex justify-content-end" ref="paginationContainer">
      <Pagination
        :currentPage="currentPage"
        :totalPages="totalPages"
        @change-page="handleChangePage"
      />
    </div>

    <div class="table-wrapper" ref="tableWrapper">
      <table class="master-table table table-bordered">
        <thead class="table-dark">
          <tr>
            <th>ID</th>
            <th>建物種別名</th>
            <th class="text-nowrap">測定表示</th>
            <th class="btn-cell"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="building_type in building_types" :key="building_type.id" :class="{ 'no-active-building-type': building_type.del_flg == 1 }">
            <td>{{ building_type.id }}</td>
            <td>{{ building_type.building_type_nm }}</td>
            <td class="text-nowrap">
              <div v-if="userRole == 0 || userRole == 999" class="form-check form-switch d-inline-block">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :checked="isVisibleInMeasure(building_type.id)"
                  @change="toggleMeasureVisibility(building_type.id, $event.target.checked)"
                >
              </div>
              <span v-else>{{ isVisibleInMeasure(building_type.id) ? '表示' : '非表示' }}</span>
            </td>
            <td class="btn-cell text-nowrap">
              <router-link :to="{ name: 'BuildingTypeDetail', params: { id: building_type.id }, query: getSearchQuery() }"> <!-- 顧客情報詳細ページへのリンク -->
                <button type="button" class="btn btn-sm btn-info">詳細</button>
              </router-link>

              <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'BuildingTypeEdit', params: { id: building_type.id }, query: getSearchQuery() }"> <!-- 顧客情報編集ページへのリンク -->
                <button type="button" class="btn btn-sm btn-success mx-2">編集</button>
              </router-link>

              <button v-if="building_type.del_flg == 0 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-danger" data-bs-toggle="modal" data-bs-target="#deleteModal" @click="handleDeleteClick(building_type.id)">削除</button>
              <button v-if="building_type.del_flg == 1 && (userRole == 0 || userRole == 999)" class="btn btn-sm btn-warning" data-bs-toggle="modal" data-bs-target="#restoreModal" @click="handleRestoreClick(building_type.id)">復元</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 削除確認モーダル -->
    <DeleteConfirmationModal
      :paramsId="paramsIdToDelete"
      @confirmDelete="handleConfirmDelete"
    />

    <!-- 復元確認モーダル -->
    <RestoreConfirmationModal
      :paramsId="paramsIdToRestore"
      @confirmRestore="handleConfirmRestore"
    />
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import {
  getBuildingTypes,
  deleteBuildingType,
  restoreBuildingType,
  exportBuildingTypesCsv,
  importBuildingTypesCsv,
  getMasterFieldVisibilities,
  updateMasterFieldVisibilities,
  getMasterRecordVisibilities,
  updateMasterRecordVisibility
} from '@/api/axios';
import { Modal } from 'bootstrap';
import SearchPanelWrapper from '@/components/searchPanels/SearchPanelWrapper.vue';
import DeleteConfirmationModal from '@/components/shared/DeleteConfirmationModal.vue';
import RestoreConfirmationModal from '@/components/shared/RestoreConfirmationModal.vue';
import Pagination from '@/components/shared/Pagination.vue';
import DeletedStatusSelect from '@/components/shared/DeletedStatusSelect.vue';

export default {
  components: {
    SearchPanelWrapper,
    DeleteConfirmationModal,
    RestoreConfirmationModal,
    Pagination,
    DeletedStatusSelect
  },
  setup() {
    const TARGET_CLIENT_SYSTEM = 'measure';
    const title = ref('建物種別情報一覧');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const building_types = ref([]);
    const selectedFile = ref(null);
    const recordVisibilityMap = ref({});
    const fieldVisibilityFields = ref([]);
    const isSavingFieldVisibility = ref(false);

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    // 検索用のデータプロパティ
    const searchName = ref('');
    const searchDeletedStatus = ref('active');

    // 削除モーダルへ渡すID
    const paramsIdToDelete = ref(null);
    const paramsIdToRestore = ref(null);

    // テーブルの高さの動的な設定
    const topFixArea = ref(null);
    const tableWrapper = ref(null);
    const paginationContainer = ref(null);

    // 検索パネルの展開状態を管理するためのリアクティブプロパティ
    const isSearchExpanded = ref(true);

    // ▼▼ 共通：検索条件をそのまま query として返す ▼▼
    const getSearchQuery = () => ({
      building_type_name: searchName.value,
      building_type_deleted_status: searchDeletedStatus.value,
      building_type_page: currentPage.value || 1
    });

    // ページネーション
    const currentPage = ref(1);
    const totalPages = ref(20); // トータルページ数を管理するためのプロパティ

    const isVisibleInMeasure = (recordId) => recordVisibilityMap.value[recordId] !== false;

    const fetchRecordVisibilities = async () => {
      const recordIds = building_types.value.map(buildingType => buildingType.id);
      if (recordIds.length === 0) {
        recordVisibilityMap.value = {};
        return;
      }

      try {
        const response = await getMasterRecordVisibilities('building_type', TARGET_CLIENT_SYSTEM, recordIds);
        const visibilities = response.data?.visibilities || {};
        recordVisibilityMap.value = Object.fromEntries(
          recordIds.map(id => [id, visibilities[String(id)] !== false])
        );
      } catch (error) {
        console.error('建物種別表示可否データの取得に失敗しました:', error);
      }
    };

    const toggleMeasureVisibility = async (recordId, visible) => {
      const previous = isVisibleInMeasure(recordId);
      recordVisibilityMap.value = { ...recordVisibilityMap.value, [recordId]: visible };

      try {
        await updateMasterRecordVisibility('building_type', TARGET_CLIENT_SYSTEM, recordId, visible);
      } catch (error) {
        recordVisibilityMap.value = { ...recordVisibilityMap.value, [recordId]: previous };
        store.dispatch('setFlashMessage', { message: '測定表示設定の更新に失敗しました', type: 'danger' });
      }
    };

    const openFieldVisibilityModal = async () => {
      try {
        const response = await getMasterFieldVisibilities('building_type', TARGET_CLIENT_SYSTEM);
        fieldVisibilityFields.value = response.data?.fields || [];
      } catch (error) {
        console.error('表示項目設定の取得に失敗しました:', error);
      }
    };

    const updateFieldReadable = (fieldName, readable) => {
      fieldVisibilityFields.value = fieldVisibilityFields.value.map(field => (
        field.field_name === fieldName ? { ...field, readable } : field
      ));
    };

    const closeFieldVisibilityModal = () => {
      const modalElement = document.getElementById('fieldVisibilityModalBuildingType');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    const saveFieldVisibility = async () => {
      isSavingFieldVisibility.value = true;
      try {
        const fields = fieldVisibilityFields.value
          .filter(field => field.configurable !== false)
          .map(field => ({
            field_name: field.field_name,
            readable: field.readable
          }));

        await updateMasterFieldVisibilities('building_type', TARGET_CLIENT_SYSTEM, fields);
        await fetchBuildingTypes(currentPage.value);
        store.dispatch('setFlashMessage', { message: '測定システム表示項目を更新しました', type: 'success' });
        closeFieldVisibilityModal();
      } catch (error) {
        store.dispatch('setFlashMessage', { message: '表示項目設定の更新に失敗しました', type: 'danger' });
      } finally {
        isSavingFieldVisibility.value = false;
      }
    };

    const fetchBuildingTypes = async (page = 1) => {
      try {
        const response = await getBuildingTypes({
          name: searchName.value,
          deleted_status: searchDeletedStatus.value,
          page: page
        });
        building_types.value = response.data.building_types;
        totalPages.value = response.data.meta.total_pages;
        currentPage.value = response.data.meta.current_page;
        await fetchRecordVisibilities();
      } catch (error) {
        console.error('建物種別情報ーデータの取得に失敗しました:', error);
      }
    };

    const handleChangePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        fetchBuildingTypes(page);

        const q = getSearchQuery();
        q.building_type_page = page;

        router.replace({
          path: '/building-types',
          query: q
        });

        // スクロールを tableWrapper のトップへ
        if (tableWrapper.value) {
          tableWrapper.value.scrollTop = 0;
        }
      }
    };

    const handleDeleteClick = (building_typeId) => {
      paramsIdToDelete.value = building_typeId;
    };

    const handleRestoreClick = (building_typeId) => {
      paramsIdToRestore.value = building_typeId;
    };
    
    const handleConfirmDelete = async (building_typeId) => {
      try {
        await deleteBuildingType(building_typeId);
        store.dispatch('setFlashMessage', { message: '建物種別情報が削除されました', type: 'success' });
        await fetchBuildingTypes(currentPage.value);
      } catch (error) {
        // エラー処理
        store.dispatch('setFlashMessage', { message: '建物種別情報削除に失敗しました', type: 'danger' });
      }
    };

    const handleConfirmRestore = async (building_typeId) => {
      try {
        await restoreBuildingType(building_typeId);
        store.dispatch('setFlashMessage', { message: '建物種別情報が復元されました', type: 'success' });
        await fetchBuildingTypes(currentPage.value);
      } catch (error) {
        store.dispatch('setFlashMessage', { message: '建物種別情報復元に失敗しました', type: 'danger' });
      }
    };

    // CSVエクスポート
    const downloadCsv = async () => {
      try {
        const response = await exportBuildingTypesCsv({
          name: searchName.value,
          deleted_status: searchDeletedStatus.value
        });

        // 現在の年月日時分秒を取得してフォーマット
        const now = new Date();
        const timestamp = `${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, "0")}${now.getDate().toString().padStart(2, "0")}_${now.getHours().toString().padStart(2, "0")}${now.getMinutes().toString().padStart(2, "0")}${now.getSeconds().toString().padStart(2, "0")}`;

        const fileName = `m_building_types_${timestamp}.csv`; // 動的なファイル名

        // CSVファイルをダウンロード
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSVダウンロードエラー", error);
      }
    };

    // CSVインポート
    const handleFileChange = (event) => {
      selectedFile.value = event.target.files[0]; // 選択されたファイルを保存
    };

    // モーダルを閉じる処理
    const closeModal = () => {
      const modalElement = document.getElementById('exampleModal');
      const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
      modal.hide();
    };

    // モーダルが閉じた後に実行される処理
    const onModalHidden = () => {
      clearErrorMessages(); // エラーメッセージをクリアする関数を呼び出す
    };

    // モーダルの閉じるボタンのアクション
    const clearErrorMessages = () => {
      errorMessages.value = {}; // エラーメッセージをクリア
      selectedFile.value = null; // ファイルをクリア

      // inputタグのvalueをリセット
      const input = document.querySelector('.form-control[type="file"]');
      if (input) {
        input.value = '';
      }
    };

    const submitFile = async () => {
      if (!selectedFile.value) {
        store.dispatch('setFlashMessage', { message: 'ファイルが選択されていません', type: 'danger' });
        return;
      }

      try {
        await importBuildingTypesCsv(selectedFile.value); // 選択されたファイルを関数に渡す
        store.dispatch('setFlashMessage', { message: 'アップロードに成功しました', type: 'success' });
        // モーダルを閉じる
        closeModal();

        // モーダルが完全に閉じた後に実行されるイベントリスナーを追加
        document.getElementById('exampleModal').addEventListener('hidden.bs.modal', onModalHidden);

        // 建物種別情報の再取得
        await fetchBuildingTypes();
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        console.error('アップロードに失敗しました', error);
        store.dispatch('setFlashMessage', { message: 'アップロードに失敗しました', type: 'danger' });
      }
    };

    // 建種別を検索するメソッド
    const searchBuildingTypes = async () => {
      await fetchBuildingTypes(1);

      const q = getSearchQuery();
      q.building_type_page = 1;

      router.push({
        path: '/building-types',
        query: q
      });
    };
    
    // 建物種別を検索リセットするメソッド
    const searchResetBuildingTypes = async () => {
      searchName.value = ''; // 名前検索条件をクリア
      searchDeletedStatus.value = 'active';
      await fetchBuildingTypes(1);

      const q = getSearchQuery();
      q.building_type_page = 1;

      router.replace({
        path: '/building-types',
        query: q
      });
    };

    // ▼▼▼ クエリパラメータから検索条件を復元 ▼▼▼
    onMounted(() => {
      const q = route.query;

      searchName.value = q.building_type_name || '';
      searchDeletedStatus.value = q.building_type_deleted_status || 'active';
      currentPage.value = q.building_type_page ? Number(q.building_type_page) : 1;

      fetchBuildingTypes(currentPage.value);
    });

    return {
      title,
      route,
      userRole,
      building_types,
      paramsIdToDelete,
      paramsIdToRestore,
      handleDeleteClick,
      handleConfirmDelete,
      handleRestoreClick,
      handleConfirmRestore,
      downloadCsv,
      selectedFile,
      handleFileChange,
      submitFile,
      errorMessages,
      clearErrorMessages,
      searchName,
      searchDeletedStatus,
      getSearchQuery,
      currentPage,
      totalPages,
      handleChangePage,
      searchBuildingTypes,
      searchResetBuildingTypes,
      isVisibleInMeasure,
      toggleMeasureVisibility,
      openFieldVisibilityModal,
      updateFieldReadable,
      saveFieldVisibility,
      fieldVisibilityFields,
      isSavingFieldVisibility,
      isSearchExpanded,
      topFixArea,
      tableWrapper,
      paginationContainer
    };
  }
};
</script>

<style scoped>
.no-active-building-type td {
  background-color: #aaa;
}
</style>
